module.exports = __webpack_public_path__ + "img/react-native.0203820d.png";